export const environment = {
    production: false,
    apiUrl: "https://dev-api-viventhealth.noveltytechnology.com/api",
    storeUrl: "https://depot.viventhealth.org",
    storeAdminUrl: "https://depot.viventhealth.org/wp-admin",
    jigsawServiceUrl: "http://69.16.202.176/~onlinedepotviven/"
};
